<div class="menu" [class.menu--collapsed]="collapsed">
  <div class="menu__header">
    <img src="/assets/images/logo.png" alt="EVMap" class="logo">
    <div class="brand">
      <span class="brand__title">EV MAP</span>
      <span class="brand__subtitle">Workspace</span>
    </div>
  </div>

  <nav class="menu__nav" aria-label="Navigation principale">
    <div class="menu__organization-selector">
      <leaf-organization-selector [reduced]="collapsed" menuXPosition="after" menuYPosition="above" adminCompleteMode="always"></leaf-organization-selector>
    </div>

    <!-- ─── Espace client ─── -->
    <div class="menu__section">
      <span class="menu__section-label">{{ 'app.menu.sections.clientSpace' | translate }}</span>
      <a mat-button routerLink="/reports"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.periodicReports' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>assessment</mat-icon>
        <span>{{ 'app.menu.links.periodicReports' | translate }}</span>
      </a>
      <a mat-button routerLink="/organization"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.settings' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>domain</mat-icon>
        <span>{{ 'app.menu.links.settings' | translate }}</span>
      </a>
      <a mat-button routerLink="/members-rights"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.membersRights' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>group</mat-icon>
        <span>{{ 'app.menu.links.membersRights' | translate }}</span>
      </a>
    </div>

    <!-- ─── EV MAP (admin) ─── -->
    <div class="menu__section" *ngIf="isAdmin$ | async">
      <span class="menu__section-label">{{ 'app.menu.sections.evmap' | translate }}</span>
      <a mat-button routerLink="/gireve-import"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.gireveImport' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>cloud_upload</mat-icon>
        <span>{{ 'app.menu.links.gireveImport' | translate }}</span>
      </a>
      <a mat-button routerLink="/bank-transfer"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.bankTransfer' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>account_balance</mat-icon>
        <span>{{ 'app.menu.links.bankTransfer' | translate }}</span>
      </a>
      <a mat-button routerLink="/admin/organizations"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.organizationsLabel' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>business</mat-icon>
        <span>{{ 'app.menu.organizationsLabel' | translate }}</span>
      </a>
    </div>

    <!-- ─── Configuration (admin) ─── -->
    <div class="menu__section" *ngIf="isAdmin$ | async">
      <span class="menu__section-label">{{ 'app.menu.sections.configuration' | translate }}</span>
      <a mat-button routerLink="/admin/workspace-settings"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.configuration' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>settings</mat-icon>
        <span>{{ 'app.menu.links.configuration' | translate }}</span>
      </a>
      <a mat-button routerLink="/pdftemplates"
         routerLinkActive="active"
         class="navigation-link"
         [matTooltip]="collapsed ? ('app.menu.links.pdfTemplates' | translate) : ''"
         matTooltipPosition="right">
        <mat-icon>description</mat-icon>
        <span>{{ 'app.menu.links.pdfTemplates' | translate }}</span>
      </a>
    </div>
  </nav>

  <div class="menu__footer">
    <a mat-button routerLink="/settings"
       routerLinkActive="active"
       class="navigation-link"
       [matTooltip]="collapsed ? ('app.menu.links.account' | translate) : ''"
       matTooltipPosition="right">
      <mat-icon>manage_accounts</mat-icon>
      <span>{{ 'app.menu.links.account' | translate }}</span>
    </a>

    <a mat-button class="navigation-link" (click)="toggleCollapse()"
       [matTooltip]="collapsed ? ('app.menu.links.expandMenu' | translate) : ''"
       matTooltipPosition="right">
      <mat-icon>{{ collapsed ? 'keyboard_double_arrow_right' : 'keyboard_double_arrow_left' }}</mat-icon>
      <span>{{ collapsed ? ('app.menu.links.expandMenu' | translate) : ('app.menu.links.collapseMenu' | translate) }}</span>
    </a>

    <a mat-button class="navigation-link" (click)="logout()"
       [matTooltip]="collapsed ? ('app.menu.logoutButtonLabel' | translate) : ''"
       matTooltipPosition="right">
      <mat-icon>logout</mat-icon>
      <span>{{ 'app.menu.logoutButtonLabel' | translate }}</span>
    </a>
  </div>
</div>
